import { motion } from "framer-motion";
import { fadeUp, stagger, viewportOnce } from "@/lib/motion";

const STEPS = [
  { t: "Choose Your Lane", d: "Decide your payer focus — Private Pay, Medicaid, or Medicare — based on budget, timeline, and market." },
  { t: "Research State Rules", d: "Understand your state's licensing, Certificate of Need, and inspection requirements before anything else." },
  { t: "Legal & Insurance", d: "Form your LLC and secure the general liability, professional, and bonding policies you're required to carry." },
  { t: "Policies & Staffing", d: "Build your operational procedures, competency assessments, and a realistic caregiver staffing plan." },
  { t: "Systems & Documentation", d: "Stand up scheduling, EVV, billing, payroll, and client/employee records so nothing falls through the cracks." },
  { t: "Credentialing", d: "Secure your NPI, register in NPPES, activate CAQH, and complete payer enrollment and screening." },
  { t: "Launch & Operate", d: "Market to case managers and referral sources, complete your first intakes, and run — not just open — your agency." },
];

export const Roadmap = ({ onRegister }) => (
  <section id="roadmap" data-testid="roadmap-section" className="relative bg-ink py-20 md:py-32">
    <div className="container-tasha">
      <div className="grid gap-14 lg:grid-cols-[0.8fr_1.2fr]">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="lg:sticky lg:top-28 lg:self-start"
        >
          <span className="overline">The Blueprint</span>
          <h2 className="mt-5 font-serif text-4xl font-semibold leading-tight tracking-tight text-cream md:text-6xl">
            Your 7-step launch <span className="font-script text-gold">roadmap</span>
          </h2>
          <p className="mt-6 font-sans text-lg font-light text-cream/70">
            You don't need everything figured out — you need to take the next
            right step, in the right order. Sequence is the strategy.
          </p>
          <button onClick={onRegister} data-testid="roadmap-register-btn" className="btn-ghost-gold mt-8">
            Walk Through It Live
          </button>
        </motion.div>

        <motion.ol
          variants={stagger}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
          className="relative border-l border-cream/10 pl-8 md:pl-12"
        >
          {STEPS.map((s, i) => (
            <motion.li
              key={i}
              variants={fadeUp}
              data-testid={`roadmap-step-${i + 1}`}
              className="relative pb-12 last:pb-0"
            >
              <span className="absolute -left-[41px] top-1 flex h-6 w-6 items-center justify-center rounded-full border border-gold/50 bg-ink md:-left-[57px]">
                <span className="h-2 w-2 rounded-full bg-gold" />
              </span>
              <span className="font-sans text-xs uppercase tracking-[0.3em] text-gold">
                Step {String(i + 1).padStart(2, "0")}
              </span>
              <h3 className="mt-2 font-serif text-2xl font-semibold text-cream md:text-3xl">
                {s.t}
              </h3>
              <p className="mt-3 max-w-xl font-sans text-base font-light leading-relaxed text-cream/65">
                {s.d}
              </p>
            </motion.li>
          ))}
        </motion.ol>
      </div>
    </div>
  </section>
);

export default Roadmap;
